module.exports = __webpack_public_path__ + "img/icon_debit_card.8de03da7.svg";